/**
 * 患者向け画面に表示しない「未確定情報」を判定するための共通ユーティリティ。
 *
 * 方針（SBDC）:
 *   ・未確定の医療情報は、推測で補完せず、患者向け画面に表示しない。
 *   ・「—」「確認中」「準備中」「確定次第掲載」等の未完成表現は非表示にする。
 *   ・「内容・範囲により異なります」「診察時にご案内します」等、
 *     それ自体が正式な患者向け案内として成立している文章は削除しない。
 */

/** 未完成とみなす文言（これらを含む値・文章は表示しない） */
const PENDING_MARKERS = [
  "確認中",
  "準備中",
  "確定次第",
  "確定し次第",
  "正式情報が確定",
  "正式な情報が確定",
  "正式情報を確認のうえ",
  "正式な情報を確認のうえ",
  "正式情報を確認したうえで",
  "本セクションに追記",
  "追記いたします",
  "追記します",
];

/** 未確定を示す単独記号（前後空白を除いた完全一致で判定する） */
const EMPTY_MARKERS = ["", "—", "-", "‐", "－"];

/**
 * 施術情報などの「値」が未確定かどうか。
 * 空文字・null・undefined・—・確認中・準備中 などを未確定として扱う。
 */
export function isPendingValue(value?: string | null): boolean {
  if (value == null) return true;
  const trimmed = value.trim();
  if (EMPTY_MARKERS.includes(trimmed)) return true;
  return PENDING_MARKERS.some((marker) => trimmed.includes(marker));
}

/**
 * 注意書き・FAQ回答などの「文章」が未完成表示かどうか。
 * 空文字・—・確認中・準備中・確定次第掲載 などを未完成として扱う。
 */
export function isPendingText(text?: string | null): boolean {
  if (text == null) return true;
  const trimmed = text.trim();
  if (trimmed === "" || trimmed === "—" || trimmed === "-") return true;
  return PENDING_MARKERS.some((marker) => trimmed.includes(marker));
}